export default __webpack_public_path__ + "static/media/WoodwarpImg.9be6ec04.png";